import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"pencil\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 1.726c1.023-1.023 2.597-.938 3.62.085 1.024 1.023 1.11 2.6.087 3.622l-.68.681c-2.558 2.558-8.673 8.74-8.673 8.74A.5.5 0 014.5 15H1v-3.567a.5.5 0 01.146-.353L10.5 1.726zm2.913.792c.633.633.72 1.576.087 2.208l-2.293-2.293c.633-.632 1.574-.547 2.206.085zM4.293 14H2v-2.36l6.998-7 .71-.705.792-.793 2.293 2.292-.789.798-.694.719L4.293 14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol